export default __webpack_public_path__ + "static/media/contact2.a1a31435.jpg";